module.exports = __webpack_public_path__ + "img/decopage.8854b04d.jpg";